import React, { useState, useEffect } from "react"
import { Tab, Tabs } from "@mui/material"
import { Button, Container, Modal } from "react-bootstrap"
import { TableProps } from "../../interfaces/CamposTablaGenerica"
import { IEventos } from "../../interfaces/IEventos"
import { TipoEvento } from "../../interfaces/TipoEvento"
import { getDescripcion } from "../../utils/tipoEventoTheme"
import "./EventosPage.css"
import EventosCardsView from "./EventosCardsView"
import EventosCalendarioView from "./EventosCalendarioView"

const VISTA_CALENDARIO_KEY = "eventosVistaCalendario"
const EVENTOS_TAB_TIPO_KEY = "eventosTabActivo"

function EventosPage({
  data,
  onAdd,
  onUpdate,
  onDelete,
}: TableProps<IEventos>) {
  const [showModal, setShowModal] = useState<boolean>(false)
  const [itemToDelete, setItemToDelete] = useState<IEventos | null>(null)
  const [vistaCalendario, setVistaCalendario] = useState<boolean>(() => {
    const saved = localStorage.getItem(VISTA_CALENDARIO_KEY)
    return saved === "true"
  })
  const [tabTipo, setTabTipo] = useState<TipoEvento | "TODOS">(() => {
    return (localStorage.getItem(EVENTOS_TAB_TIPO_KEY) as TipoEvento | "TODOS") ?? "TODOS"
  })

  // Persistir estado de vista en localStorage
  useEffect(() => {
    localStorage.setItem(VISTA_CALENDARIO_KEY, String(vistaCalendario))
  }, [vistaCalendario])

  const handleDeleteConfirm = () => {
    if (itemToDelete && onDelete) {
      onDelete(itemToDelete)
      setItemToDelete(null)
      setShowModal(false)
    }
  }

  const handleShowModal = (item: IEventos) => {
    setItemToDelete(item)
    setShowModal(true)
  }

  const handleToggleVista = (value: boolean) => {
    setVistaCalendario(value)
  }

  const handleAdd = (fechaDefecto?: string) => {
    onAdd?.(fechaDefecto, vistaCalendario ? undefined : normalModeTab)
  }

  const handleTabTipoChange = (_: React.SyntheticEvent, val: TipoEvento) => {
    setTabTipo(val)
    localStorage.setItem(EVENTOS_TAB_TIPO_KEY, val)
  }

  // En modo normal el tab activo nunca puede ser "TODOS": si viene de localStorage con ese valor, usar el primer tipo
  const normalModeTab: TipoEvento =
    tabTipo === "TODOS" ? Object.values(TipoEvento)[0] : (tabTipo as TipoEvento)

  const filteredData = vistaCalendario
    ? data
    : data.filter((e) => e.tipo === normalModeTab)

  return (
    <Container fluid>
      {!vistaCalendario && (
        <Tabs
          value={normalModeTab}
          onChange={handleTabTipoChange}
          sx={{ mb: 1 }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          {Object.values(TipoEvento).map((tipo) => (
            <Tab
              key={tipo}
              label={`${getDescripcion(tipo)} (${data.filter((e) => e.tipo === tipo).length})`}
              value={tipo}
            />
          ))}
        </Tabs>
      )}
      {vistaCalendario ? (
        <EventosCalendarioView
          data={filteredData}
          onAdd={handleAdd}
          onUpdate={onUpdate}
          onDelete={handleShowModal}
          vistaCalendario={vistaCalendario}
          onToggleVista={handleToggleVista}
        />
      ) : (
        <EventosCardsView
          data={filteredData}
          onAdd={handleAdd}
          onUpdate={onUpdate}
          onDelete={handleShowModal}
          vistaCalendario={vistaCalendario}
          onToggleVista={handleToggleVista}
        />
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Eliminacion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estas seguro de que deseas eliminar este evento?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm}>
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default EventosPage
